import { useBacklogSelector } from '../index';
import { getInsightsPanel } from '../selectors/panels';
import { isBacklogWithSprints } from '../selectors/sprints';

export const useIsInsightsPanelOpen = () => {
	const isInsightsPanelVisible = useBacklogSelector(getInsightsPanel);
	const hasSprints = useBacklogSelector(isBacklogWithSprints);
	return hasSprints && isInsightsPanelVisible;
};
